import { styled, Theme } from '@mui/material';

export const sxStyles = {
  schoolOffersMainContainer: {
    marginTop: '4rem',
  },
  schoolOffersHeaderTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  schoolOffersTitle: (theme: Theme) => ({
    padding: '1.25rem 2rem',
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  }),
  specialProgramsTitle: {
    marginBottom: '1rem',
  },
  extracurricularsTitle: {
    marginTop: '2rem',
  },
  programContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '1rem',
  },
};

export const StyledSchoolOffersWrap = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: '100%',
  marginTop: '2.5rem',
  boxShadow: '0px 5px 25px rgba(17, 77, 76, 0.1)',
  borderRadius: '0.5rem',
}));

export const StyledSchoolOffersInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  margin: '0 4.75rem 0 3.5rem',
  padding: '2.5rem 0 4rem 0',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  '& > div:last-of-type': {
    marginLeft: '1rem',
  },

  [theme.breakpoints.down('md')]: {
    margin: '0 2rem',
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',

    '& > div:last-of-type': {
      marginLeft: 0,
      marginTop: '2.5rem',
    },
  },
}));

export const StyledProgramIconWrap = styled('div')(() => ({
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'center',
  maxWidth: '20px',
  width: '100%',
  marginRight: '0.75rem',
}));
